import React from 'react';

export const Error404 = () => {
  return <div>Error 404: Strona o takim adresie nie istnieje</div>;
};
